"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Sarah Jenkins",
  quote: "The IV therapy at MO Protocol has completely transformed my energy levels. The atmosphere is incredibly calming and professional.",
  position: "Midland, TX",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/client_sarah_midland.png",
  initials: "SJ"
}, {
  author: "Michael Ross",
  quote: "A premium experience from start to finish. The wellness rooms provide a level of tranquility I haven't found anywhere else in West Texas.",
  position: "Odessa, TX",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/client_michael_odessa.png",
  initials: "MR"
}, {
  author: "Elena Rodriguez",
  quote: "Their vitamin injections and lab testing services are efficient and high-end. I finally feel like I have a partner in my health journey.",
  position: "Midland, TX",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/client_elena_midland.png",
  initials: "ER"
}];
export default function OgrenciVeOgretmenGorusleri() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="228730" id="client-experiences" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
        <div className="w-full max-w-[800px] aspect-square bg-[radial-gradient(circle_at_center,hsl(30,20%,95%),transparent_70%)] rounded-full blur-3xl opacity-40" />
      </div>

      <div className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-4xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="p-2 md:p-6">
                    <Card className="bg-transparent border-none shadow-none">
                      <CardContent className="flex flex-col items-center text-center p-6 md:p-10">
                        <div className="relative mb-8">
                          <SafeHydrate><Avatar className="size-20 md:size-24 border-2 border-border shadow-sm">
                            <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                            <AvatarFallback className="text-xl bg-secondary text-secondary-foreground font-default">
                              {testimonial.initials}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          <div className="absolute -bottom-3 -right-3 bg-primary text-primary-foreground p-2 rounded-full shadow-md">
                            <Quote className="size-4 md:size-5" />
                          </div>
                        </div>

                        <Badge variant="outline" className="mb-6 text-xs px-4 py-1 font-default tracking-widest uppercase border-border text-muted-foreground">
                          {testimonial.position}
                        </Badge>

                        <blockquote className="text-2xl md:text-4xl leading-relaxed italic font-default text-foreground mb-8 max-w-3xl">
                          "{testimonial.quote}"
                        </blockquote>

                        <div className="mt-auto">
                          <cite className="not-italic font-default font-medium text-lg tracking-wide text-primary">
                            {testimonial.author}
                          </cite>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex items-center justify-center gap-4 mt-8">
              <CarouselPrevious className="relative inset-auto translate-x-0 translate-y-0 bg-background hover:bg-primary hover:text-primary-foreground border-border transition-all duration-300 shadow-sm" />
              <CarouselNext className="relative inset-auto translate-x-0 translate-y-0 bg-background hover:bg-primary hover:text-primary-foreground border-border transition-all duration-300 shadow-sm" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}